// AUTO-GENERATED FILE — DO NOT EDIT BY HAND.
// Source of truth: backend/app/services/engine_dag.py
// Regenerate with: python backend/scripts/codegen_frontend_engines.py
// CI parity check: backend/tests/test_engine_codegen_parity.py

/** All engine ids in the backend computation DAG. */
export type EngineId =
  | 'merchant_reconciliation'
  | 'merchant_revenue_augmentation'
  | 'bottom_up'
  | 'enhanced_claim'
  | 'dual_method'
  | 'mitigation'
  | 'impact'
  | 'epi'
  | 'policy_deductions'
  | 'pv'
  | 'fair_settlement'
  | 'case_strength'
  | 'property'
  | 'projection_trend'
  | 'two_period'
  | 'capacity_ceiling'
  | 'non_recurring_item_detector'
  | 'catch_up_sales'
  | 'monthly_limit_cap'
  | 'extra_expense_cap'
  | 'third_party_damages'
  | 'tort_lost_profits'
  | 'l_recon';

/** Engine ids in backend DAG declaration order. */
export const ALL_ENGINE_IDS: readonly EngineId[] = [
  'merchant_reconciliation',
  'merchant_revenue_augmentation',
  'bottom_up',
  'enhanced_claim',
  'dual_method',
  'mitigation',
  'impact',
  'epi',
  'policy_deductions',
  'pv',
  'fair_settlement',
  'case_strength',
  'property',
  'projection_trend',
  'two_period',
  'capacity_ceiling',
  'non_recurring_item_detector',
  'catch_up_sales',
  'monthly_limit_cap',
  'extra_expense_cap',
  'third_party_damages',
  'tort_lost_profits',
  'l_recon',
] as const;

/** Backend display names (ENGINE_METADATA[id].display_name). */
export const GENERATED_ENGINE_NAMES: Record<EngineId, string> = {
  merchant_reconciliation: 'P&L Reconciliation',
  merchant_revenue_augmentation: 'Revenue Augmentation',
  bottom_up: 'Bottom-Up Loss',
  enhanced_claim: 'Enhanced Claim',
  dual_method: 'Dual-Method Reconciler',
  mitigation: 'Mitigation Deductions',
  impact: 'Impact Analysis',
  epi: 'Extended Period of Indemnity',
  policy_deductions: 'Policy Deductions',
  pv: 'Present Value',
  fair_settlement: 'Fair Settlement',
  case_strength: 'Case Strength',
  property: 'Property Valuation (RCV/ACV)',
  projection_trend: 'Projection / Trend',
  two_period: 'Two-Period',
  capacity_ceiling: 'Capacity Ceiling Detection',
  non_recurring_item_detector: 'Non-Recurring Item Detector',
  catch_up_sales: 'Catch-Up Sales Offset',
  monthly_limit_cap: 'Monthly Limit of Indemnity Cap',
  extra_expense_cap: 'Extra Expense Cap',
  third_party_damages: 'Third-Party Demand',
  tort_lost_profits: 'Tort Lost Profits',
  l_recon: 'Subrogation Allocation',
};

/** Engine dependency DAG (upstream inputs per engine). */
export const GENERATED_ENGINE_DEPENDENCIES: Record<EngineId, EngineId[]> = {
  merchant_reconciliation: [],
  merchant_revenue_augmentation: ['merchant_reconciliation'],
  bottom_up: ['merchant_reconciliation', 'merchant_revenue_augmentation'],
  enhanced_claim: ['merchant_reconciliation', 'merchant_revenue_augmentation'],
  dual_method: ['bottom_up', 'enhanced_claim'],
  mitigation: ['dual_method'],
  impact: ['dual_method'],
  epi: ['impact', 'bottom_up'],
  policy_deductions: ['dual_method'],
  pv: ['dual_method', 'mitigation', 'policy_deductions', 'impact', 'epi'],
  fair_settlement: ['pv', 'policy_deductions'],
  case_strength: ['fair_settlement'],
  property: [],
  projection_trend: ['merchant_reconciliation', 'merchant_revenue_augmentation'],
  two_period: ['merchant_reconciliation', 'merchant_revenue_augmentation'],
  capacity_ceiling: ['merchant_reconciliation', 'merchant_revenue_augmentation'],
  non_recurring_item_detector: ['merchant_reconciliation', 'merchant_revenue_augmentation'],
  catch_up_sales: ['projection_trend', 'two_period'],
  monthly_limit_cap: ['policy_deductions', 'bottom_up'],
  extra_expense_cap: ['dual_method'],
  third_party_damages: ['tort_lost_profits', 'property', 'extra_expense_cap'],
  tort_lost_profits: ['merchant_reconciliation', 'merchant_revenue_augmentation'],
  l_recon: ['third_party_damages', 'policy_deductions'],
};
